import React from 'react';

export default function BrandMark({ size = 'md' }) {
    const text = size === 'sm' ? 'text-[15px]' : 'text-[17px]';
    return (
        <span className='flex items-center ' data-testid='brand-mark'>
            <span
                aria-hidden
                className='text-[inherit] font-sans-display font-semibold tracking-tight text-foreground '
            >
                creston
            </span>
            <span className='text-yellow-400 font-black text-[28px]  -translate-y-[4.3px]'>
                .
            </span>
        </span>
    );
}
